import { render, staticRenderFns } from "./EditorComp.vue?vue&type=template&id=0254bc44&scoped=true&"
import script from "./EditorComp.vue?vue&type=script&lang=js&"
export * from "./EditorComp.vue?vue&type=script&lang=js&"
import style0 from "./EditorComp.vue?vue&type=style&index=0&id=0254bc44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0254bc44",
  null
  
)

export default component.exports